import React, { useEffect, useState } from 'react';
import { getDashboardStats } from '../utils/api';

const NAVY = '#0d2137';
const GREEN = '#1a6b3c';
const RED = '#c41e3a';

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const userName = localStorage.getItem('dha_name') || 'User';

  useEffect(() => {
    getDashboardStats()
      .then(r => setStats(r.data))
      .catch(() => setStats(null))
      .finally(() => setLoading(false));
  }, []);

  const cards = [
    { label: "Today's Patients", value: stats?.today_patients ?? '—', color: NAVY, icon: '👥', sub: 'Registered today' },
    { label: "Today's Revenue", value: stats?.today_fees != null ? `PKR ${Number(stats.today_fees).toLocaleString()}` : '—', color: GREEN, icon: '💰', sub: 'Consultation fees' },
    { label: 'Appointments Today', value: stats?.today_appointments ?? '—', color: RED, icon: '📅', sub: 'Scheduled visits' },
    { label: 'Total Patients', value: stats?.total_patients ?? '—', color: '#7c3aed', icon: '🏥', sub: 'All time' },
    { label: 'Total Doctors', value: stats?.total_doctors ?? '—', color: '#0891b2', icon: '🩺', sub: 'Active doctors' },
    { label: "This Month", value: stats?.this_month ?? '—', color: '#d97706', icon: '📊', sub: 'Patients this month' },
  ];

  return (
    <div style={{ padding: '32px 28px' }}>
      <h1 style={{ color: NAVY, fontSize: 26, fontWeight: 900, marginBottom: 4 }}>Dashboard</h1>
      <div style={{ color: '#64748b', marginBottom: 28, fontSize: 14 }}>
        Welcome back, <b style={{ color: NAVY }}>{userName}</b> — DHA Medical Centre Overview
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 60, color: '#94a3b8', fontSize: 15 }}>Loading stats...</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 20 }}>
          {cards.map(card => (
            <div key={card.label} style={{
              background: '#fff', borderRadius: 12, padding: '24px 20px',
              boxShadow: '0 2px 10px rgba(0,0,0,0.07)', borderTop: `4px solid ${card.color}`
            }}>
              <div style={{ fontSize: 28 }}>{card.icon}</div>
              <div style={{ fontSize: 28, fontWeight: 900, color: card.color, marginTop: 8 }}>{card.value}</div>
              <div style={{ fontSize: 13, color: '#374151', fontWeight: 600, marginTop: 4 }}>{card.label}</div>
              <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>{card.sub}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
